import React from 'react';
import * as LucideIcons from 'lucide-react';

const ServiceAreas = () => {
  const areas = [
    { name: 'Ipswich', region: 'Suffolk', featured: true },
    { name: 'Colchester', region: 'Essex', featured: true },
    { name: 'Woodbridge', region: 'Suffolk', featured: false },
    { name: 'Felixstowe', region: 'Suffolk', featured: false },
    { name: 'Bury St Edmunds', region: 'Suffolk', featured: false },
    { name: 'Chelmsford', region: 'Essex', featured: false },
    { name: 'Clacton-on-Sea', region: 'Essex', featured: false },
    { name: 'Stratford', region: 'London', featured: true },
    { name: 'East London', region: 'London', featured: false },
    { name: 'Stowmarket', region: 'Suffolk', featured: false },
    { name: 'Hadleigh', region: 'Suffolk', featured: false },
    { name: 'Braintree', region: 'Essex', featured: false },
  ];

  const regions = [
    { name: 'Suffolk', description: 'Our home county - fastest response times', icon: LucideIcons.Home },
    { name: 'Essex', description: 'Full coverage across the county', icon: LucideIcons.Building2 },
    { name: 'London', description: 'East & Central London areas', icon: LucideIcons.Landmark },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <span className="text-orange-600 font-semibold text-sm uppercase tracking-wider">Coverage Area</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4">Areas We Serve</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            T&M Construction provides professional building and renovation services across Suffolk, Essex, and London
          </p>
        </div>

        {/* Main Regions */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {regions.map((region) => (
            <div key={region.name} className="bg-gray-50 rounded-2xl p-8 text-center hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <region.icon className="w-8 h-8 text-orange-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">{region.name}</h3>
              <p className="text-gray-600">{region.description}</p>
            </div>
          ))}
        </div>

        {/* Towns & Cities */}
        <div className="bg-gray-900 rounded-2xl p-8 md:p-12">
          <h3 className="text-xl font-bold text-white mb-6 text-center">Towns & Cities We Cover</h3>
          <div className="flex flex-wrap justify-center gap-3">
            {areas.map((area) => (
              <span 
                key={area.name}
                className={`px-4 py-2 rounded-full text-sm font-medium ${
                  area.featured 
                    ? 'bg-orange-600 text-white' 
                    : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                } transition-colors`}
              >
                {area.name}
              </span>
            ))}
          </div>
          <p className="text-center text-gray-400 mt-6 text-sm">
            <LucideIcons.MapPin className="w-4 h-4 inline mr-1" />
            Don't see your area? Contact us - we may still be able to help!
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
